



export default function ShareholderTile({ shareholders }: {
    shareholders: Array<{
        id: number;
        firstName: string;
        lastName: string;
        position: string;
    }>;
}) {
    const getInitials = (firstName: string, lastName: string) => {
        return (firstName?.[0] + lastName?.[0] || "").toUpperCase();
    };

    
    return (
        <>
            {shareholders?.map((shareholder) => (
                <div key={shareholder.id} className="flex items-center justify-between px-6 py-2 bg-white rounded-xl shadow-sm border border-gray-100">
                    <div className="flex items-center gap-4">
                        <div className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center">
                            <span className="text-sm text-orange-500 font-medium">
                                {getInitials(shareholder.firstName, shareholder.lastName)}
                            </span>
                        </div>
                        <div className="space-y-1">
                            <div className="flex flex-col  text-sm text-gray-500">
                                <span>{shareholder.firstName} {shareholder.lastName}</span>
                                <span>{shareholder.position}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
}